import type { BlogGroup } from '../fr/blogGroups';

/**
 * Article index categories.
 *
 * Labels taken verbatim from the English blog index on solutions-asterion.com,
 * so that both sites name the same groups the same way.
 */
export const BLOG_GROUPS: BlogGroup[] = [
  {
    label: 'My approach',
    slugs: [
      'notre-approche-qualite-pme-manufacturiere',
      'structurer-demarche-qualite-pme-manufacturiere',
    ],
  },
  {
    label: 'The quality system',
    slugs: [
      'rendre-iso-9001-accessible-pme-ia',
      'revue-direction-iso-9001-sans-consultant',
      'points-critiques-systeme-qualite',
      'maturite-systeme-qualite-pme',
      'jamais-vu-systeme-qualite-pme',
    ],
  },
  {
    label: 'The report & measurement',
    slugs: [
      'rapport-usinage-inspection-quatre-lectures',
      'cout-cache-temps-machiniste-rapports-inspection',
      'ocr-plans-cotes-manufacturier',
      'metrologie-hors-excel-etalonnage',
    ],
  },
  {
    label: 'AI, tools & organization',
    slugs: [
      'ia-qualite-ce-quelle-peut-faire',
      'batir-logiciels-metier-ia-encadree',
      'innovateur-interne-adoption-logiciel-pme',
      'ecosysteme-pas-silos-bon-de-travail',
      'plans-heberges-quebec-loi-25',
    ],
  },
  {
    label: 'Near you',
    slugs: [
      'logiciel-qualite-usinage-sorel-tracy',
      'logiciel-qualite-usinage-drummondville',
      'logiciel-qualite-usinage-trois-rivieres-mauricie',
      'logiciel-qualite-usinage-montreal',
      'logiciel-qualite-usinage-saguenay-lac-saint-jean',
    ],
  },
];
